import { render } from "./Pagination.vue?vue&type=template&id=0e1fe725"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e1fe725"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e1fe725', __exports__)) {
    console.log('reload')
    api.reload('0e1fe725', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=0e1fe725", () => {
    console.log('re-render')
    api.rerender('0e1fe725', render)
  })

}


export default __exports__